// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1647":"1e0851cc113674a5","2284":"6af91a9450047a08","2481":"8b4d1ead83fc400e","5641":"e3f918fc1af7f5e2"}[chunkId] + ".css";
};